export enum PatientGender {
  Masculino = 'Masculino',
  Feminino = 'Feminino',
  Outro = 'Outro',
}